import { useQuery } from "@tanstack/react-query";
import { getUrl } from "src/basepath";
import { useQueryAppInfo } from "src/queries/info/info.query";

const ASSISTANT_API_READY_URL = getUrl("/assistant-api/ready");

const fetchAssistantApiReady = async (signal: AbortSignal): Promise<boolean> => {
  try {
    const response = await fetch(ASSISTANT_API_READY_URL, { signal });
    if (!response.ok) return false;
    const body: unknown = await response.json();
    return (body as { status?: string })?.status === "ready";
  } catch {
    return false;
  }
};

export const useIsAiAssistantEnabled = () => {
  const isEnabledForTenant =
    useQueryAppInfo().data?.is_ai_assistant_enabled ?? false;

  const { data: isAssistantApiReady } = useQuery({
    queryKey: ["assistant-api-ready"],
    queryFn: ({ signal }) => fetchAssistantApiReady(signal),
    enabled: isEnabledForTenant,
    staleTime: 60_000,
    retry: false,
  });

  return isEnabledForTenant && (isAssistantApiReady ?? false);
};
